import request from '@/utils/request'

/**
 * 创建子账号
 */
export const addSubAccount = async (data) =>
  request({ url: '/subAccount/add', method: 'POST', data })

/**
 * 编辑子账号
 */
export const editSubAccount = async (data) =>
  request({ url: '/subAccount/edit', method: 'POST', data })

/**
 * 删除子账号
 */
export const deleteSubAccount = async (data) =>
  request({ url: '/subAccount/delete', method: 'POST', data })

/**
 * 子账号列表
 */
export const getSubAccountList = async (data) =>
  request({ url: '/subAccount/list', method: 'POST', data })

/**
 * 子账号登录
 */
export const subAccountLogin = async (data) =>
  request({ url: '/subAccount/login', method: 'POST', data })
